
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const ExclamationCircleIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M52 66C52 68.2091 50.2091 70 48 70C45.7909 70 44 68.2091 44 66C44 63.7909 45.7909 62 48 62C50.2091 62 52 63.7909 52 66Z" fill="#161617"/>
<path d="M51.5 29.5C51.5 27.567 49.933 26 48 26C46.067 26 44.5 27.567 44.5 29.5V54.5C44.5 56.433 46.067 58 48 58C49.933 58 51.5 56.433 51.5 54.5V29.5Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M8 48C8 25.9086 25.9086 8 48 8C70.0914 8 88 25.9086 88 48C88 70.0914 70.0914 88 48 88C25.9086 88 8 70.0914 8 48ZM48 15C29.7746 15 15 29.7746 15 48C15 66.2254 29.7746 81 48 81C66.2254 81 81 66.2254 81 48C81 29.7746 66.2254 15 48 15Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M84.5 48C84.5 68.1584 68.1584 84.5 48 84.5C27.8416 84.5 11.5 68.1584 11.5 48C11.5 27.8416 27.8416 11.5 48 11.5C68.1584 11.5 84.5 27.8416 84.5 48Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M52 66C52 68.2091 50.2091 70 48 70C45.7909 70 44 68.2091 44 66C44 63.7909 45.7909 62 48 62C50.2091 62 52 63.7909 52 66Z" fill="#161617"/>
<path d="M51.5 29.5C51.5 27.567 49.933 26 48 26C46.067 26 44.5 27.567 44.5 29.5V54.5C44.5 56.433 46.067 58 48 58C49.933 58 51.5 56.433 51.5 54.5V29.5Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M8 48C8 25.9086 25.9086 8 48 8C70.0914 8 88 25.9086 88 48C88 70.0914 70.0914 88 48 88C25.9086 88 8 70.0914 8 48ZM48 15C29.7746 15 15 29.7746 15 48C15 66.2254 29.7746 81 48 81C66.2254 81 81 66.2254 81 48C81 29.7746 66.2254 15 48 15Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M84.5 48C84.5 68.1584 68.1584 84.5 48 84.5C27.8416 84.5 11.5 68.1584 11.5 48C11.5 27.8416 27.8416 11.5 48 11.5C68.1584 11.5 84.5 27.8416 84.5 48Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
